
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 30 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M0 0h30v6.7H0V0z","fill":"#ED2939"}}),_c('path',{attrs:{"d":"M0 6.7h30v6.7H0V6.7z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 13.3h30V20H0v-6.7z","fill":"#ED2939"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 3a3 3 0 013-3h24a3 3 0 013 3v14a3 3 0 01-3 3H3a3 3 0 01-3-3V3z","fill":"#fff"}})])])])
          )
        }
      }
    